exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pd-view-doc-container{height:100% !important;max-height:100% !important;border-radius:0}.pd-view-doc-container .yxt-dialog__body{height:100%;padding:0}.pd-view-doc-container .yxt-scrollbar__view{height:100%}\n", ""]);

